// environment-banner.component.ts
import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-environment-banner',
    templateUrl: './environment-banner.component.html',
    styleUrls: ['./environment-banner.component.css'],
})
export class EnvironmentBannerComponent {
    //bannerText = environment.bannerText;
    bannerText: string;

    ngOnInit(): void {
        this.bannerText = environment.bannerText;
    }
    // Assuming you have 'production' flag in environment files
}
